import {
    IS_LOADING_LIST_PQRS_ADMIN,LIST_PQRS_ADMIN,IS_LOADING_RESPONSE_PQRS_ADMIN,RESPONSE_PQRS_ADMIN,DISABLE_PQRS_ADMIN
} from '../actions/types'
    
    const initialState = {

        isLoadingListPQRSAdmin:false,
        listPQRSAdmin:[],
        isLoadingResponsePQRSAdmin:false,
        responsePQRSAdmin:'' 
    }

export default function (state = initialState, action) {
    switch (action.type) {

    case IS_LOADING_LIST_PQRS_ADMIN:
        return { ...state, isLoadingListPQRSAdmin:true}
    case LIST_PQRS_ADMIN:
        console.log()
        return { ...state, listPQRSAdmin:action.payload, isLoadingListPQRSAdmin:false}
    case IS_LOADING_RESPONSE_PQRS_ADMIN:
        return { ...state, isLoadingResponsePQRSAdmin:true}
    case RESPONSE_PQRS_ADMIN:
        const listPQRSAdmin = state.listPQRSAdmin.filter(pqrq =>{
       
            return pqrq._id !== action.payload._id
        })
    
        return { ...state, listPQRSAdmin: listPQRSAdmin, isLoadingResponsePQRSAdmin: false } 
    case DISABLE_PQRS_ADMIN:
        var disablePQRS = state.listPQRSAdmin
        disablePQRS.splice(action.payload, 1)
        return { ...state, isLoadingListPQRSAdmin:false, listPQRSAdmin: disablePQRS}
    
    default:
    return state
        
        }
    }